// Where a receipt came from. Online orders arrive from the store's website
// (eastbay.direct posts a receipts row with import_source "eastbay"); POS
// file imports use their own source names (generic_csv, ...) and receipts
// made on the floor have no import_source at all. The dashboard shows a
// loud "Online order" banner on anything this says is online, so the floor
// can tell at a glance that nobody in the store wrote it up.

const ONLINE_SOURCES = new Set([
  'eastbay',
  'online',
  'web',
  'website',
  'ecommerce',
  'shopify',
  'woocommerce',
  'online_store',
]);

const SOURCE_SITES = {
  eastbay: 'eastbay.direct',
};

export const isOnlineOrder = (receipt) => {
  if (!receipt) return false;
  const src = String(receipt.import_source || receipt.importSource || '').trim().toLowerCase();
  if (src && ONLINE_SOURCES.has(src)) return true;
  const sold = String(receipt.salesperson || '').trim().toLowerCase();
  return sold === 'eastbay.direct';
};

// "eastbay.direct" for the East Bay site; the raw source name otherwise, or
// nothing when the only clue was the salesperson.
export const onlineOrderSite = (receipt) => {
  if (!isOnlineOrder(receipt)) return '';
  const src = String(receipt.import_source || receipt.importSource || '').trim().toLowerCase();
  if (SOURCE_SITES[src]) return SOURCE_SITES[src];
  if (String(receipt.salesperson || '').trim().toLowerCase() === 'eastbay.direct') return 'eastbay.direct';
  return src && !['online', 'web', 'website', 'ecommerce', 'online_store'].includes(src) ? src : '';
};

// The line the banners print: "Online order · eastbay.direct".
export const onlineOrderLabel = (receipt) => {
  const site = onlineOrderSite(receipt);
  return site ? `Online order · ${site}` : 'Online order';
};
